export interface PagedResponse<T> {
  items: T[];
  nextPage?: string | null;
}

/**
 * Walks a continuation-token endpoint one page at a time.
 *
 * Yields instead of collecting, so a caller that only needs the first match can
 * stop paging by leaving the loop, and one that needs the lot can keep going.
 */
export async function* fetchPages<T>(
  fetchPage: (
    continuationToken: string | undefined
  ) => Promise<PagedResponse<T>>
): AsyncGenerator<T[]> {
  let continuationToken: string | undefined;

  do {
    const page = await fetchPage(continuationToken);

    yield page.items;

    // Stop on any empty token, not just null: an empty one binds to no token
    // server-side, so treating it as "continue" would re-request page one
    // forever.
    continuationToken = page.nextPage ?? undefined;
  } while (continuationToken);
}
